import React from 'react';
import { ListBoxItemElement, ListBoxItemSkeleton } from './list-box.styles.js';
export const ListBoxLoadingSkeleton = () => (React.createElement(ListBoxItemElement, { disablePointerEvents: true },
    React.createElement(ListBoxItemSkeleton, null)));
//# sourceMappingURL=list-box-loading-skeleton.component.js.map